export default function BlankPage() {
  return <div className="container page-content" />;
}
